import React from "react";
import styles from "./MenuItem.module.scss";
import classnames from "classnames";

interface MenuItemProps {
  children: React.ReactNode;
  viewOnly?: boolean;
  "data-testid"?: string;
}

export default function MenuItem({
  children,
  viewOnly,
  "data-testid": dataTestId = "menu-item",
}: MenuItemProps) {
  return (
    <div
      className={classnames(styles.root, { [styles.clickable]: !viewOnly })}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
}
